import { createAction } from 'redux-actions';

export const changeThemeToDark = createAction('CHANGE_THEME_TO_DARK');
export const changeThemeToLight = createAction('CHANGE_THEME_TO_LIGHT');
